import {h} from 'preact';

export default function Fieldset(props){
	if (props.hide)
	{
		return null;
	}

	return (
		<fieldset className={`form-field ${props.horizontal ? '':'form-field_dir-min-md_row form-block__item form-block__item_mgt_xs'} ${props.hasErrors ? 'form-field_state_error':''}`}>
			<div className="form-field__inner">
				<div className="form-field__title-row">
					<legend className="form-field__title">{props.title}</legend>
				</div>
				<div className={`form-field__input-row form-field__input-row_min-ht_none ${props.hasErrors ? 'form-field_state_error':''}`}>
					{props.children}
				</div>
			</div>
		</fieldset>
	)
}